import {createSelector, MemoizedSelector} from '@ngrx/store';
import {Persona, personasAdapter, PersonasState} from './personas.state';

import {FeaturesState, selectFeatures} from '../../../features.state';

export const getError = (state: PersonasState): any => state.error;

export const getIsLoading = (state: PersonasState): boolean =>
  state.isLoading;

export const selectPersonasState = createSelector(
  selectFeatures,
  (state: FeaturesState) => state.personas
);

export const selectAllPersonas: (state: object) => Persona[] = personasAdapter.getSelectors(
  selectPersonasState
).selectAll;

export const selectPersonaById = (id: string) =>
  createSelector(
    selectAllPersonas,
    (allPersonas: Persona[]) => {
      if (allPersonas) {
        return allPersonas.find(p => p.personaId === id);
      } else {
        return null;
      }
    }
  );

export const selectPersonasError: MemoizedSelector<object, any> = createSelector(
  selectPersonasState,
  getError
);

export const selectPersonasIsLoading: MemoizedSelector<object, boolean> = createSelector(
  selectPersonasState,
  getIsLoading
);
